export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-competencies-item.vue?vue&type=template&id=092b1ee2&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-competencies-item/lk-competencies-item.vue?vue&type=template&id=092b1ee2&
// module id = 1329
// module chunks = 0